// 신규 store_type enum 키 집합 //
const NEW_ENUM_KEYS = new Set([
  'crossfit', 'hyrox', 'crossTraining', 'pilates', 'pt', 'groupPt',
  'bodyCorrection', 'weightTraining', 'bodybuilding', 'dietProgram',
  'bodyProfile', 'womensFitness', 'seniorFitness', 'kidsFitness',
  'gxProgram', 'functionalTraining', 'personalTraining', 'rehabTraining',
  'sportsPerformance', 'powerlifting', 'flyingYoga', 'vinyasaYoga',
  'cyclingClass', 'muaythaiFitness', 'mmaFitness', 'jiujitsuConditioning',
  'runningClass', 'marathonTraining', 'hiitTraining', 'circuitTraining',
  'coreTraining', 'kettlebellTraining', 'stretchingClass', 'mobilityClass',
  'calisthenics', 'strongmanTraining', 'emsTraining', 'others'
]);

// 레거시 값(한국어/영어 표기 변형 포함) → 신규 enum 키 매핑 //
const LEGACY_TO_NEW_MAP = {
  // Korean legacy
  '1 : 1 PT': 'pt',
  '1:1 PT': 'pt',
  'PT': 'pt',
  '그룹 트레이닝': 'groupPt',
  '부티크 피트니스': 'functionalTraining',
  '일반 피트니스 센터': 'weightTraining',
  '필라테스': 'pilates',
  '크로스핏': 'crossfit',
  '농구': 'others',
  '테니스': 'others',
  '야구': 'others',
  '축구': 'others',
  '스피닝': 'cyclingClass',
  '발레': 'others',
  '복싱': 'others',
  '댄스': 'others',
  '골프': 'others',
  '기타': 'others',
  // English legacy
  'Group Training': 'groupPt',
  'groupTraining': 'groupPt',
  'Boutique Fitness': 'functionalTraining',
  'General Fitness Center': 'weightTraining',
  'Pilates': 'pilates',
  'Yoga': 'vinyasaYoga',
  'yoga': 'vinyasaYoga',
  'CrossFit': 'crossfit',
  'Basketball': 'others',
  'Tennis': 'others',
  'tennis': 'others',
  'Baseball': 'others',
  'Soccer': 'others',
  'Spinning': 'cyclingClass',
  'Ballet': 'others',
  'Boxing': 'others',
  'Dance': 'others',
  'Golf': 'others',
  'Other': 'others',
  'other': 'others'
};

// 레거시 또는 비표준 store_type 값을 신규 enum 키로 정규화 //
function normalizeCenterType(value) {
  if (!value) return '';

  if (NEW_ENUM_KEYS.has(value)) return value;

  const mapped = LEGACY_TO_NEW_MAP[value];

  if (mapped !== undefined) return mapped;

  return 'others';
}

export { normalizeCenterType };
